import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import LeaderboardWidgetFavoriteComponent from './js/leaderboard-widget-favorite.component';

ComponentsFactory.getInstance().define('leaderboard-widget-favorite', LeaderboardWidgetFavoriteComponent);
